import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import infinityIcon from "@/assets/infinity.svg";
import { useTranslation } from "@/hooks/useTranslation";
import SelectRecurringPlanIOS from "./SelectRecurringPlanIOS";

export default function SelectRevenueCatPlanCard() {
  const t = useTranslation();

  return (
    <Card className="dark w-full max-w-lg rounded-3xl mx-auto">
      <CardHeader className="pb-4">
        <CardTitle className="text-xl text-center">
          {t.SELECT_PLAN_CARD.LABELS.TITLE}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col items-center text-center gap-y-5">
          <img src={infinityIcon} className="w-36 mx-auto" />
          <div className="font-thin">
            {t.SELECT_PLAN_CARD.LABELS.DESCRIPTION}
          </div>
          <SelectRecurringPlanIOS />
        </div>
      </CardContent>
    </Card>
  );
}
